export class StaticAmplitudeAlarmParameters {

  constructor(
    public threshold: number = null,
    public period: number = null,
    public channel: number = null
  ) {
  }

}
